import {MODULE_TYPES} from '../../../constants';

/**
 * Temporary method, for checking if modules should be checked.
 * This is used in the transition period, where modules are introduced.
 */
export const checkModule = featureFlags => {
	if (!Array.isArray(featureFlags)) {
		throw Error(`FeatureFlags should be an array of feature flags for the company. FeatureFlags was '${featureFlags}'`);
	}
	return featureFlags.some(featureFlag => featureFlag.key === 'use_modules');
};

/**
 * @param moduleType The type of module to check for. Must be one of MODULE_TYPES
 * @param modules Array of modules that the company has.
 */
export const hasModule = (moduleType, modules) => {
	if (!MODULE_TYPES[moduleType]) {
		throw Error(`Unknown module of type '${moduleType}'`);
	}

	if (!Array.isArray(modules)) {
		throw Error(`Modules should be an array of modules for the company. The module should contain at least 'moduleType' property. Modules was '${modules}'`);
	}

	return modules.some(module => module.moduleType === moduleType);
};
